module.exports = __webpack_public_path__ + "img/logo_full_big.d3795cab.svg";